import { Routes } from "@angular/router";
import { MainComponent } from "./core/main/main.component";
import { ProductListComponent } from "./core/product-list/product-list.component";
import { PhoneComponent } from "./core/phone/phone.component";
import { AuthGuard } from "./shared/guards/auth_gaurd";
import { OrderTypeGuard } from "./shared/guards/order-type_guard";
import { CheckoutComponent } from "./core/checkout/checkout.component";
import { ControlPanelComponent } from "./layouts/admin/control-panel/control-panel.component";
import { AdminGaurd } from "./shared/guards/admin-gaurd";
export const AppRoutes: Routes = [
  {
    path: "",
    component: MainComponent,
  },
  {
    path: "all-products",
    component: ProductListComponent,
    canActivate: [OrderTypeGuard],
  },
  {
    path: "phone",
    component: PhoneComponent

  },
  {
    path: "checkout",
    component: CheckoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin",
    component: ControlPanelComponent,
    canActivate: [AdminGaurd]
  }
  // ,
  // {
  // 	path: 'users',
  // 	component: UserComponent,
  // 	canActivate: [AuthGuard],
  // 	children: [
  // 		{
  // 			path: '',
  // 			component: UserAccountComponent,
  // 			outlet: 'profileOutlet'
  // 		}
  // 	]
  // },
  // {
  // 	path: 'control-panel',
  // 	component: ControlPanelComponent
  // 	// canActivate: [AuthGuard]
  // },
  // {
  // 	path: 'products',
  // 	component: ProductListComponent
  // },
  // {
  // 	path: 'order-success/:OrderId',
  // 	component: OrderCompleteComponent
  // },
  // {
  // 	path: 'products/all-products',
  // 	component: ProductListComponent
  // },
  // {
  // 	path: 'products/favourite-products',
  // 	component: FavouriteProductsComponent
  // },
  // {
  // 	path: 'products/cart-items',
  // 	component: CartProductsComponent
  // },
  // {
  // 	path: 'products/product/:ProductId',
  // 	component: ProductDetailComponent
  // },

  // {
  // 	path: 'checkouts',
  // 	component: CheckoutComponent,
  // 	canActivate: [AuthGuard],
  // 	children: [
  // 		{
  // 			path: '',
  // 			component: ProductsComponent,
  // 			outlet: 'checkOutlet'
  // 		},
  // 		{
  // 			path: 'billing-details',
  // 			component: BillingDetailsComponent,
  // 			outlet: 'checkOutlet'
  // 		},
  // 		{
  // 			path: 'result',
  // 			component: ResultComponent,
  // 			outlet: 'checkOutlet'
  // 		}
  // 	]
  // },
  // {
  // 	path: "login",
  // 	component: LoginComponent
  // },
  // { path: 'no-access', component: NoAccessComponent },
  // { path: '**', component: PageNotFoundComponent }
];
